import * as React from 'react'

import './OddsHeaderStyles.scss';
import useTranslation from '../../hooks/useTranslation';

const OddsHeader = () => {
  const currentSetText = useTranslation('Odds_currentSet_caps');
  const currentGameText = useTranslation('Odds_currentGame_caps');
  const currentPointText = useTranslation('Odds_currentPoint_caps');
  return (
    <div className="oddsHeaderRowWrapper">
      <div className="placeholderOddsHeader"></div>
      <div className="oddsWrapperGrid">
        <div className="sr-grid sr-row-align-center oddsHeaderRow">
          <div className="sr-cell sr-xs-1-3 sr-cell-align-center">
            <div className="sr-content sr-align-center oddsMarketSet">{currentSetText}</div>
          </div>
          <div className="sr-cell sr-xs-1-3 sr-cell-align-center">
            <div className="sr-content sr-align-center oddsMarketCurrentGame">{currentGameText}</div>
          </div>
          <div className="sr-cell sr-xs-1-3 sr-cell-align-center">
            <div className="sr-content sr-align-center oddsMarketCurrentPoint">{currentPointText}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OddsHeader